module.exports = __webpack_public_path__ + "img/bk_18_02.80c89596.png";